__turbopack_context__.v({
  "box": "newsletter-module-scss-module___qmEka__box",
  "button": "newsletter-module-scss-module___qmEka__button",
  "error": "newsletter-module-scss-module___qmEka__error",
  "form": "newsletter-module-scss-module___qmEka__form",
  "header": "newsletter-module-scss-module___qmEka__header",
  "input": "newsletter-module-scss-module___qmEka__input",
  "popup": "newsletter-module-scss-module___qmEka__popup",
  "success": "newsletter-module-scss-module___qmEka__success",
  "wrapper": "newsletter-module-scss-module___qmEka__wrapper",
});
